import * as p from "react";
import { r as M } from "./index-CcPSJ6_x.mjs";
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function E() {
  return E = Object.assign ? Object.assign.bind() : function(l) {
    for (var s = 1; s < arguments.length; s++) {
      var e = arguments[s];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (l[n] = e[n]);
    }
    return l;
  }, E.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function y() {
  return y = Object.assign ? Object.assign.bind() : function(l) {
    for (var s = 1; s < arguments.length; s++) {
      var e = arguments[s];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (l[n] = e[n]);
    }
    return l;
  }, y.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function g(l, s, e) {
  var n, t = (n = e.initialDeps) != null ? n : [], r;
  return function() {
    var o;
    e.key && e.debug != null && e.debug() && (o = Date.now());
    var i = l(), a = i.length !== t.length || i.some(function(m, d) {
      return t[d] !== m;
    });
    if (!a)
      return r;
    t = i;
    var u;
    if (e.key && e.debug != null && e.debug() && (u = Date.now()), r = s.apply(void 0, i), e.key && e.debug != null && e.debug()) {
      var f = Math.round((Date.now() - o) * 100) / 100, c = Math.round((Date.now() - u) * 100) / 100, v = c / 16, h = function(d, b) {
        for (d = String(d); d.length < b; )
          d = " " + d;
        return d;
      };
      console.info("%c⏱ " + h(c, 5) + " /" + h(f, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * v, 120)) + "deg 100% 31%);", e == null ? void 0 : e.key);
    }
    return e == null || e.onChange == null || e.onChange(r), r;
  };
}
function I(l, s) {
  if (l === void 0)
    throw new Error("Unexpected undefined" + (s ? ": " + s : ""));
  return l;
}
var z = function(s, e) {
  return Math.abs(s - e) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var T = function(s) {
  return s;
}, C = function(s) {
  for (var e = Math.max(s.startIndex - s.overscan, 0), n = Math.min(s.endIndex + s.overscan, s.count - 1), t = [], r = e; r <= n; r++)
    t.push(r);
  return t;
}, w = function(s, e) {
  var n = s.scrollElement;
  if (n) {
    var t = function(i) {
      var a = i.width, u = i.height;
      e({
        width: Math.round(a),
        height: Math.round(u)
      });
    };
    t(n.getBoundingClientRect());
    var r = new ResizeObserver(function(o) {
      var i = o[0];
      if (i != null && i.borderBoxSize) {
        var a = i.borderBoxSize[0];
        if (a) {
          t({
            width: a.inlineSize,
            height: a.blockSize
          });
          return;
        }
      }
      t(n.getBoundingClientRect());
    });
    return r.observe(n, {
      box: "border-box"
    }), function() {
      r.unobserve(n);
    };
  }
}, D = function(s, e) {
  var n = s.scrollElement;
  if (n) {
    var t = function() {
      e(n[s.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    return t(), n.addEventListener("scroll", t, {
      passive: !0
    }), function() {
      n.removeEventListener("scroll", t);
    };
  }
}, R = function(s, e, n) {
  if (e != null && e.borderBoxSize) {
    var t = e.borderBoxSize[0];
    if (t) {
      var r = Math.round(t[n.options.horizontal ? "inlineSize" : "blockSize"]);
      return r;
    }
  }
  return Math.round(s.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]);
}, N = function(s, e, n) {
  var t, r, o = e.adjustments, i = o === void 0 ? 0 : o, a = e.behavior, u = s + i;
  (t = n.scrollElement) == null || t.scrollTo == null || t.scrollTo((r = {}, r[n.options.horizontal ? "left" : "top"] = u, r.behavior = a, r));
}, j = function(s) {
  var e = this;
  this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ function() {
    var n = null, t = function() {
      return n || (typeof ResizeObserver < "u" ? n = new ResizeObserver(function(o) {
        o.forEach(function(i) {
          e._measureElement(i.target, i);
        });
      }) : null);
    };
    return {
      disconnect: function() {
        var o;
        return (o = t()) == null ? void 0 : o.disconnect();
      },
      observe: function(o) {
        var i;
        return (i = t()) == null ? void 0 : i.observe(o, {
          box: "border-box"
        });
      },
      unobserve: function(o) {
        var i;
        return (i = t()) == null ? void 0 : i.unobserve(o);
      }
    };
  }(), this.range = null, this.setOptions = function(n) {
    Object.entries(n).forEach(function(t) {
      var r = t[0], o = t[1];
      typeof o > "u" && delete n[r];
    }), e.options = y({
      debug: !1,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: !1,
      getItemKey: T,
      rangeExtractor: C,
      onChange: function() {
      },
      measureElement: R,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, n);
  }, this.notify = function(n) {
    e.options.onChange == null || e.options.onChange(e, n);
  }, this.maybeNotify = g(function() {
    return e.calculateRange(), [e.isScrolling, e.range ? e.range.startIndex : null, e.range ? e.range.endIndex : null];
  }, function(n) {
    e.notify(n);
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function() {
      return e.options.debug;
    },
    initialDeps: [this.isScrolling, this.range ? this.range.startIndex : null, this.range ? this.range.endIndex : null]
  }), this.cleanup = function() {
    e.unsubs.filter(Boolean).forEach(function(n) {
      return n();
    }), e.unsubs = [], e.scrollElement = null;
  }, this._didMount = function() {
    return e.measureElementCache.forEach(e.observer.observe), function() {
      e.observer.disconnect(), e.cleanup();
    };
  }, this._willUpdate = function() {
    var n = e.options.getScrollElement();
    e.scrollElement !== n && (e.cleanup(), e.scrollElement = n, e._scrollToOffset(e.scrollOffset, {
      adjustments: void 0,
      behavior: void 0
    }), e.unsubs.push(e.options.observeElementRect(e, function(t) {
      e.scrollRect = t, e.maybeNotify();
    })), e.unsubs.push(e.options.observeElementOffset(e, function(t) {
      e.scrollAdjustments = 0, e.scrollOffset !== t && (e.isScrollingTimeoutId !== null && (clearTimeout(e.isScrollingTimeoutId), e.isScrollingTimeoutId = null), e.isScrolling = !0, e.scrollDirection = e.scrollOffset < t ? "forward" : "backward", e.scrollOffset = t, e.maybeNotify(), e.isScrollingTimeoutId = setTimeout(function() {
        e.isScrollingTimeoutId = null, e.isScrolling = !1, e.scrollDirection = null, e.maybeNotify();
      }, e.options.scrollingDelay));
    })));
  }, this.getSize = function() {
    return e.scrollRect[e.options.horizontal ? "width" : "height"];
  }, this.memoOptions = g(function() {
    return [e.options.count, e.options.paddingStart, e.options.scrollMargin, e.options.getItemKey];
  }, function(n, t, r, o) {
    return e.pendingMeasuredCacheIndexes = [], {
      count: n,
      paddingStart: t,
      scrollMargin: r,
      getItemKey: o
    };
  }, {
    key: !1
  }), this.getFurthestMeasurement = function(n, t) {
    for (var r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), i = t - 1; i >= 0; i--) {
      var a = n[i];
      if (!r.has(a.lane)) {
        var u = o.get(a.lane);
        if (u == null || a.end > u.end ? o.set(a.lane, a) : a.end < u.end && r.set(a.lane, !0), r.size === e.options.lanes)
          break;
      }
    }
    return o.size === e.options.lanes ? Array.from(o.values()).sort(function(f, c) {
      return f.end - c.end;
    })[0] : void 0;
  }, this.getMeasurements = g(function() {
    return [e.memoOptions(), e.itemSizeCache];
  }, function(n, t) {
    var r = n.count, o = n.paddingStart, i = n.scrollMargin, a = n.getItemKey, u = e.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, e.pendingMeasuredCacheIndexes) : 0;
    e.pendingMeasuredCacheIndexes = [];
    for (var f = e.measurementsCache.slice(0, u), c = u; c < r; c++) {
      var v = a(c), h = e.options.lanes === 1 ? f[c - 1] : e.getFurthestMeasurement(f, c), m = h ? h.end : o + i, d = t.get(v), b = typeof d == "number" ? d : e.options.estimateSize(c), S = m + b, x = h ? h.lane : c % e.options.lanes;
      f[c] = {
        index: c,
        start: m,
        size: b,
        end: S,
        key: v,
        lane: x
      };
    }
    return e.measurementsCache = f, f;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function() {
      return e.options.debug;
    }
  }), this.calculateRange = g(function() {
    return [e.getMeasurements(), e.getSize(), e.scrollOffset];
  }, function(n, t, r) {
    return e.range = n.length > 0 && t > 0 ? _({
      measurements: n,
      outerSize: t,
      scrollOffset: r
    }) : null;
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function() {
      return e.options.debug;
    }
  }), this.getIndexes = g(function() {
    return [e.options.rangeExtractor, e.calculateRange(), e.options.overscan, e.options.count];
  }, function(n, t, r, o) {
    return t === null ? [] : n(y({}, t, {
      overscan: r,
      count: o
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return e.options.debug;
    }
  }), this.indexFromElement = function(n) {
    var t = e.options.indexAttribute, r = n.getAttribute(t);
    return r ? parseInt(r, 10) : (console.warn("Missing attribute name '" + t + "={index}' on measured element."), -1);
  }, this._measureElement = function(n, t) {
    var r = e.measurementsCache[e.indexFromElement(n)];
    if (!r || !n.isConnected) {
      e.measureElementCache.forEach(function(a, u) {
        a === n && (e.observer.unobserve(n), e.measureElementCache.delete(u));
      });
      return;
    }
    var o = e.measureElementCache.get(r.key);
    o !== n && (o && e.observer.unobserve(o), e.observer.observe(n), e.measureElementCache.set(r.key, n));
    var i = e.options.measureElement(n, t, e);
    e.resizeItem(r, i);
  }, this.resizeItem = function(n, t) {
    var r, o = (r = e.itemSizeCache.get(n.key)) != null ? r : n.size, i = t - o;
    i !== 0 && (n.start < e.scrollOffset && (process.env.NODE_ENV !== "production" && e.options.debug && console.info("correction", i), e._scrollToOffset(e.scrollOffset, {
      adjustments: e.scrollAdjustments += i,
      behavior: void 0
    })), e.pendingMeasuredCacheIndexes.push(n.index), e.itemSizeCache = new Map(e.itemSizeCache.set(n.key, t)), e.notify(!1));
  }, this.measureElement = function(n) {
    n && e._measureElement(n, void 0);
  }, this.getVirtualItems = g(function() {
    return [e.getIndexes(), e.getMeasurements()];
  }, function(n, t) {
    for (var r = [], o = 0, i = n.length; o < i; o++) {
      var a = n[o], u = t[a];
      r.push(u);
    }
    return r;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return e.options.debug;
    }
  }), this.getVirtualItemForOffset = function(n) {
    var t = e.getMeasurements();
    return I(t[O(0, t.length - 1, function(r) {
      return I(t[r]).start;
    }, n)]);
  }, this.getOffsetForAlignment = function(n, t) {
    var r = e.getSize();
    t === "auto" && (n <= e.scrollOffset ? t = "start" : n >= e.scrollOffset + r ? t = "end" : t = "start"), t === "start" ? n = n : t === "end" ? n = n - r : t === "center" && (n = n - r / 2);
    var o = e.options.horizontal ? "scrollWidth" : "scrollHeight", i = e.scrollElement ? "document" in e.scrollElement ? e.scrollElement.document.documentElement[o] : e.scrollElement[o] : 0, a = i - e.getSize();
    return Math.max(Math.min(a, n), 0);
  }, this.getOffsetForIndex = function(n, t) {
    t === void 0 && (t = "auto"), n = Math.max(0, Math.min(n, e.options.count - 1));
    var r = I(e.getMeasurements()[n]);
    if (t === "auto")
      if (r.end >= e.scrollOffset + e.getSize() - e.options.scrollPaddingEnd)
        t = "end";
      else if (r.start <= e.scrollOffset + e.options.scrollPaddingStart)
        t = "start";
      else
        return [e.scrollOffset, t];
    var o = t === "end" ? r.end + e.options.scrollPaddingEnd : r.start - e.options.scrollPaddingStart;
    return [e.getOffsetForAlignment(o, t), t];
  }, this.isDynamicMode = function() {
    return e.measureElementCache.size > 0;
  }, this.cancelScrollToIndex = function() {
    e.scrollToIndexTimeoutId !== null && (clearTimeout(e.scrollToIndexTimeoutId), e.scrollToIndexTimeoutId = null);
  }, this.scrollToOffset = function(n, t) {
    var r = t === void 0 ? {} : t, o = r.align, i = o === void 0 ? "start" : o, a = r.behavior;
    e.cancelScrollToIndex(), a === "smooth" && e.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), e._scrollToOffset(e.getOffsetForAlignment(n, i), {
      adjustments: void 0,
      behavior: a
    });
  }, this.scrollToIndex = function(n, t) {
    var r = t === void 0 ? {} : t, o = r.align, i = o === void 0 ? "auto" : o, a = r.behavior;
    n = Math.max(0, Math.min(n, e.options.count - 1)), e.cancelScrollToIndex(), a === "smooth" && e.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    var u = e.getOffsetForIndex(n, i), f = u[0], c = u[1];
    e._scrollToOffset(f, {
      adjustments: void 0,
      behavior: a
    }), a !== "smooth" && e.isDynamicMode() && (e.scrollToIndexTimeoutId = setTimeout(function() {
      e.scrollToIndexTimeoutId = null;
      var v = e.measureElementCache.has(e.options.getItemKey(n));
      if (v) {
        var h = e.getOffsetForIndex(n, c), m = h[0];
        z(m, e.scrollOffset) || e.scrollToIndex(n, {
          align: c,
          behavior: a
        });
      } else
        e.scrollToIndex(n, {
          align: c,
          behavior: a
        });
    }));
  }, this.scrollBy = function(n, t) {
    var r = t === void 0 ? {} : t, o = r.behavior;
    e.cancelScrollToIndex(), o === "smooth" && e.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), e._scrollToOffset(e.scrollOffset + n, {
      adjustments: void 0,
      behavior: o
    });
  }, this.getTotalSize = function() {
    var n;
    return (((n = e.getMeasurements()[e.options.count - 1]) == null ? void 0 : n.end) || e.options.paddingStart) - e.options.scrollMargin + e.options.paddingEnd;
  }, this._scrollToOffset = function(n, t) {
    var r = t.adjustments, o = t.behavior;
    e.options.scrollToFn(n, {
      behavior: o,
      adjustments: r
    }, e);
  }, this.measure = function() {
    e.itemSizeCache = /* @__PURE__ */ new Map(), e.notify(!1);
  }, this.setOptions(s), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach(function(n) {
    e.itemSizeCache.set(n.key, n.size);
  }), this.maybeNotify();
}, O = function(s, e, n, t) {
  for (; s <= e; ) {
    var r = (s + e) / 2 | 0, o = n(r);
    if (o < t)
      s = r + 1;
    else if (o > t)
      e = r - 1;
    else
      return r;
  }
  return s > 0 ? s - 1 : 0;
};
function _(l) {
  for (var s = l.measurements, e = l.outerSize, n = l.scrollOffset, t = s.length - 1, r = function(u) {
    return s[u].start;
  }, o = O(0, t, r, n), i = o; i < t && s[i].end < n + e; )
    i++;
  return {
    startIndex: o,
    endIndex: i
  };
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var k = typeof document < "u" ? p.useLayoutEffect : p.useEffect;
function F(l) {
  var s = p.useReducer(function() {
    return {};
  }, {})[1], e = E({}, l, {
    onChange: function(o, i) {
      i ? M.flushSync(s) : s(), l.onChange == null || l.onChange(o, i);
    }
  }), n = p.useState(function() {
    return new j(e);
  }), t = n[0];
  return t.setOptions(e), p.useEffect(function() {
    return t._didMount();
  }, []), k(function() {
    return t._willUpdate();
  }), t;
}
function $(l) {
  return F(E({
    observeElementRect: w,
    observeElementOffset: D,
    scrollToFn: N
  }, l));
}
export {
  $ as u
};
